/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CancelTraceabilitySourceContextMutationResponse,
  CancelTraceabilitySourceContextPathParams,
} from "../types/CancelTraceabilitySourceContext.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const cancelTraceabilitySourceContextMutationKey = () =>
  [{ url: "/v1/traceability-source-contexts/:id/cancel" }] as const

export type CancelTraceabilitySourceContextMutationKey = ReturnType<
  typeof cancelTraceabilitySourceContextMutationKey
>

/**
 * @description Transitions a DRAFT or REQUEST_LAUNCHED context to CANCELLED and releases its duplicate key.
 * @summary Cancel a traceability source context
 * {@link /v1/traceability-source-contexts/:id/cancel}
 */
export async function cancelTraceabilitySourceContext(
  id: CancelTraceabilitySourceContextPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    CancelTraceabilitySourceContextMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/v1/traceability-source-contexts/${id}/cancel`,
    ...requestConfig,
  })
  return res
}

export function cancelTraceabilitySourceContextMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = cancelTraceabilitySourceContextMutationKey()
  return mutationOptions<
    ResponseConfig<CancelTraceabilitySourceContextMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: CancelTraceabilitySourceContextPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return cancelTraceabilitySourceContext(id, config)
    },
  })
}

/**
 * @description Transitions a DRAFT or REQUEST_LAUNCHED context to CANCELLED and releases its duplicate key.
 * @summary Cancel a traceability source context
 * {@link /v1/traceability-source-contexts/:id/cancel}
 */
export function useCancelTraceabilitySourceContext<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CancelTraceabilitySourceContextMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: CancelTraceabilitySourceContextPathParams["id"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? cancelTraceabilitySourceContextMutationKey()

  const baseOptions = cancelTraceabilitySourceContextMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CancelTraceabilitySourceContextMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: CancelTraceabilitySourceContextPathParams["id"] },
    TContext
  >

  return useMutation<
    ResponseConfig<CancelTraceabilitySourceContextMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: CancelTraceabilitySourceContextPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CancelTraceabilitySourceContextMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: CancelTraceabilitySourceContextPathParams["id"] },
    TContext
  >
}
